import React from 'react';

const NoMatch = () => {
  return (
    <div>
      No Page
    </div>
  );
};

export default NoMatch;


// WEBPACK FOOTER //
// ./src/routes/NoMatch.js